/**
 * An element's rendered width, kept current while it resizes (a
 * `ResizeObserver`). `null` until it has been measured; a zero width (the
 * element is hidden, e.g. `display: none`) keeps the last real one.
 */
import React from "react";

export function useElementWidth(element: HTMLElement | null): number | null {
  const [width, setWidth] = React.useState<number | null>(null);
  // Measured before paint, so a narrow element never flashes the wide layout.
  React.useLayoutEffect(() => {
    if (!element) return undefined;
    const update = (next: number) => {
      if (next > 0) setWidth(next);
    };
    update(element.getBoundingClientRect().width);
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(() =>
      update(element.getBoundingClientRect().width)
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);
  return width;
}
